import {
    Button,
    DatePicker,
    Drawer,
    Form,
    Input,
    Select,
    message,
} from "antd";
import CalendarCustom from "../Calendar/CalendarCustom";
import "react-calendar/dist/Calendar.css";
import locale from "antd/es/date-picker/locale/vi_VN";
import dayjs from "dayjs";
import "moment/locale/vi";
import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import BgForm from "../../images/bg-form-2.png";
import { dateFilterAir } from "../../helpers/formatDate";
import CustomInputNumber from "../Common/CustomInputNumber";

const DesktopStep1 = ({
    form,
    onChangeStep,
    tripType,
    setTripType,
    setAirport,
    airports,
    loadingAirPorts,
    setFilterDay,
    setFilterDayReturn,
    token,
}) => {
    const listAirPortVn = ["HAN", "SGN", "DAD", "CXR", "HPH", "PQC"];
    const startpoint = Form.useWatch("startpoint", form);
    const endpoint = Form.useWatch("endpoint", form);
    const adtCount = Form.useWatch("Adt", form);
    const chdCount = Form.useWatch("Chd", form);
    const infCount = Form.useWatch("Inf", form);
    const [valueCalendar, setValueCalendar] = useState(new Date());
    const [airportsDom, setAirportsDom] = useState([]);
    const [airportsFor, setAirportsFor] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [nameField, setNameField] = useState("startpoint");
    const [openCalendar, setOpenCalendar] = useState(false);
    const [typeCalendar, setTypeCalendar] = useState("");
    const [minDateCalendar, setMinDateCalendar] = useState(new Date());

    const handleSelect = (value) => {
        form.setFieldValue(nameField, value);
        setOpenDrawer(false);
    };

    const removeDiacritics = (str) => {
        if (!str) return "";
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
    };

    const filterAirports = useMemo(() => {
        if (airportsDom.length) {
            const arr = [];
            const airPortFilter = airportsDom.filter((item) =>
                removeDiacritics(`${item.namevn} ${item?.countrynamevn} ${item.countrycode} ${item.countryname} ${item.airports.map((ap) => ap.namevn).join(" ")}`)
                    .toLowerCase().includes(removeDiacritics(searchTerm).toLowerCase())
            );
            listAirPortVn.forEach((code) => {
                const index = airPortFilter.findIndex((item) => item.code === code);
                if (index > -1) { arr.push(airPortFilter[index]); airPortFilter.splice(index, 1); }
            });
            arr.push(...airPortFilter);
            return arr;
        }
        return [];
    }, [airportsDom, searchTerm]);

    const filterAirportsFor = useMemo(() => {
        if (airportsFor.length) {
            const globalFilter = airportsFor.filter((item) =>
                removeDiacritics(`${item.namevn} ${item?.countrynamevn} ${item.countrycode} ${item.countryname}`)
                    .toLowerCase().includes(removeDiacritics(searchTerm).toLowerCase())
            );
            const classifiedByCountry = globalFilter.reduce((acc, item) => {
                const { countrycode } = item;
                if (!acc[countrycode]) acc[countrycode] = [];
                if (acc[countrycode].length < 30) acc[countrycode].push(item);
                return acc;
            }, {});
            return _.values(classifiedByCountry);
        }
        return [];
    }, [airportsFor, searchTerm]);

    const onFinish = async (values) => {
        if (values.startpoint === values.endpoint) { message.error("Điểm đi và đến không được trùng nhau!"); return; }
        const departDate = dayjs(values.DepartDate).startOf("day");
        const today = dayjs().startOf("day");
        if (departDate.isBefore(today)) { message.error("Ngày khởi hành không hợp lệ!"); return; }
        const startdate = new Date(values.DepartDate);
        const returnDate = new Date(values.ReturnDate);
        setAirport([values.startpoint, values.endpoint]);
        setFilterDay(dateFilterAir(startdate));
        values.ReturnDate && setFilterDayReturn(dateFilterAir(returnDate));
        onChangeStep(2);
    };

    useEffect(() => {
        setAirportsDom(airports.filter((item) => item.countrycode === "VN" && item.code !== "VCL"));
        setAirportsFor(airports.filter((item) => item.countrycode !== "VN"));
    }, [airports]);

    const handleSwap = () => {
        form.setFieldsValue({
            startpoint: form.getFieldValue("endpoint"),
            endpoint: form.getFieldValue("startpoint"),
        });
    };

    const handleValuesFormChange = (changedValues, allValues) => {
        const DepartDate = allValues.DepartDate;
        const ReturnDate = allValues.ReturnDate;
        if (DepartDate && DepartDate.isBefore(dayjs(), "day")) {
            message.error("Ngày đi phải lớn hơn hoặc bằng ngày hiện tại!");
            form.setFieldsValue({ DepartDate: null });
        }
        if (ReturnDate && DepartDate && ReturnDate.isBefore(DepartDate, "day")) {
            message.error("Ngày về phải lớn hơn hoặc bằng ngày đi!");
            form.setFieldsValue({ ReturnDate: null });
        }
    };

    const onOpenChange = (type) => {
        setValueCalendar(form.getFieldValue(type) ?? new Date());
        setOpenCalendar(true);
        setTypeCalendar(type);
        if (type === "ReturnDate") {
            setMinDateCalendar(new Date(form.getFieldValue("DepartDate")));
        } else {
            setMinDateCalendar(new Date());
        }
    };

    const setValue = (value) => {
        form.setFieldValue(typeCalendar, dayjs(value));
        setValueCalendar(value);
        if (typeCalendar === "DepartDate" && form.getFieldValue("ReturnDate") && dayjs(value) > form.getFieldValue("ReturnDate")) {
            const newReturnDate = dayjs(value).add(3, "day");
            form.setFieldValue("ReturnDate", newReturnDate);
        }
        setOpenCalendar(false);
    };

    return (
        <div className="desktop-step1-container" style={{ minHeight: '100vh', background: '#f0f4f8', display: 'flex', flexDirection: 'column', fontFamily: "'Inter', sans-serif" }}>
            <CalendarCustom
                openCalendar={openCalendar} setOpenCalendar={setOpenCalendar}
                typeCalendar={typeCalendar} form={form} valueCalendar={valueCalendar}
                setValue={setValue} minDate={minDateCalendar}
            />

            {/* HEADER OVERLAY */}
            <header style={{
                position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 10,
                padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                background: 'linear-gradient(to bottom, rgba(0,0,0,0.5), transparent)'
            }}>
                <div onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}><img src={process.env.PUBLIC_URL + '/images/logo_ufone.png'} alt="Ufone" style={{ height: '44px' }} /></div>
                <div
                    onClick={() => onChangeStep(0)}
                    style={{
                        display: 'flex', gap: '8px', alignItems: 'center', cursor: 'pointer',
                        background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
                        padding: '8px 20px', borderRadius: '24px', color: 'white', transition: 'all 0.2s',
                        border: '1px solid rgba(255,255,255,0.2)', fontWeight: 600, fontSize: '14px'
                    }}
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Lịch sử đặt vé
                </div>
            </header>

            {/* HERO BANNER */}
            <div style={{
                position: 'relative', width: '100%', paddingTop: '60px', paddingBottom: '140px',
                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1d4ed8 100%)',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
            }}>
                <img src={BgForm} alt="Banner" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.15, mixBlendMode: 'overlay' }} />
                <h1 style={{ fontSize: '42px', fontWeight: 800, color: 'white', marginBottom: '8px', zIndex: 1, textShadow: '0 2px 12px rgba(0,0,0,0.3)' }}>
                    Khám Phá Thế Giới Cùng Mobifone
                </h1>
                <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '17px', zIndex: 1, marginBottom: '0' }}>
                    Đặt vé máy bay dễ dàng, nhanh chóng với chi phí tối ưu nhất
                </p>
            </div>

            {/* MAIN SEARCH BOX */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '0 16px' }}>
                <div style={{
                    width: '100%', maxWidth: '1100px', background: 'white', borderRadius: '20px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)', padding: '28px 32px',
                    position: 'relative', zIndex: 20, marginTop: '-100px'
                }}>
                    {/* Trip Type Toggle */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #e2e8f0' }}>
                        {[{ key: 'oneWay', label: 'Một chiều' }, { key: 'roundTrip', label: 'Khứ hồi' }].map(t => (
                            <div key={t.key} onClick={() => setTripType(t.key)}
                                style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                <div style={{
                                    width: '18px', height: '18px', borderRadius: '50%',
                                    border: `2px solid ${tripType === t.key ? '#2563eb' : '#cbd5e1'}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                                }}>
                    {tripType === t.key && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#2563eb' }} />}
                </div>
                <span style={{ fontWeight: 600, fontSize: '15px', color: tripType === t.key ? '#2563eb' : '#64748b' }}>{t.label}</span>
        </div>
    ))
}
                    </div >

    <Form className="dt-search-form" form={form} onFinish={onFinish} layout="vertical" onValuesChange={handleValuesFormChange}
        initialValues={{ startpoint: "HAN", endpoint: "SGN", DepartDate: dayjs(), Adt: 1, Chd: 0, Inf: 0 }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end' }}>
            {/* Airport Selectors */}
            <div style={{
                flex: 1, display: 'flex', gap: '0', border: '1px solid #e2e8f0', borderRadius: '12px',
                padding: '8px', background: '#f8fafc', position: 'relative', alignItems: 'center'
            }}>
                <Form.Item className="mb-0" style={{ flex: 1, marginBottom: 0, paddingRight: '20px' }} name="startpoint">
                    <Select className="w-full" style={{ height: '52px' }}
                        variant="borderless" showSearch={false} open={false} dropdownStyle={{ display: 'none' }}
                        onClick={() => { setOpenDrawer(true); setNameField("startpoint"); }}
                        options={[
                            { options: airportsDom.map((item) => ({ label: <div style={{ display: 'flex', flexDirection: 'column' }}><span style={{ fontWeight: 600, color: '#1e293b', fontSize: '15px' }}>{item.namevn}</span><span style={{ color: '#94a3b8', fontSize: '12px' }}>{item.code}</span></div>, value: item.code })) },
                            { options: airportsFor.map((item) => ({ label: <div style={{ display: 'flex', flexDirection: 'column' }}><span style={{ fontWeight: 600, color: '#1e293b', fontSize: '15px' }}>{item.namevn || item.name}</span><span style={{ color: '#94a3b8', fontSize: '12px' }}>{item.code}</span></div>, value: item.code })) }
                        ]}
                    />
                </Form.Item>

                <div style={{ width: '1px', background: '#e2e8f0', height: '40px' }} />

                {/* Swap Button */}
                <div onClick={handleSwap} style={{
                    width: '40px', height: '40px', borderRadius: '50%', background: 'white',
                    boxShadow: '0 4px 12px rgba(37, 99, 235, 0.15)', border: '1px solid #bae6fd',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
                    zIndex: 10, cursor: 'pointer', transition: 'all 0.2s', color: '#2563eb'
                }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = '#eff6ff'; e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.08)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(37, 99, 235, 0.2)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'white'; e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.15)'; }}
                >
                    <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                    </svg>
                </div>

                <Form.Item className="mb-0" style={{ flex: 1, marginBottom: 0, paddingLeft: '20px' }} name="endpoint">
                    <Select className="w-full" style={{ height: '52px' }}
                        variant="borderless" showSearch={false} open={false} dropdownStyle={{ display: 'none' }}
                        onClick={() => { setOpenDrawer(true); setNameField("endpoint"); }}
                        options={[
                            { options: airportsDom.map((item) => ({ label: <div style={{ display: 'flex', flexDirection: 'column' }}><span style={{ fontWeight: 600, color: '#1e293b', fontSize: '15px' }}>{item.namevn}</span><span style={{ color: '#94a3b8', fontSize: '12px' }}>{item.code}</span></div>, value: item.code })) },
                            { options: airportsFor.map((item) => ({ label: <div style={{ display: 'flex', flexDirection: 'column' }}><span style={{ fontWeight: 600, color: '#1e293b', fontSize: '15px' }}>{item.namevn || item.name}</span><span style={{ color: '#94a3b8', fontSize: '12px' }}>{item.code}</span></div>, value: item.code })) }
                        ]}
                    />
                </Form.Item>
            </div>

            {/* Date Pickers */}
            <div style={{
                width: tripType === 'roundTrip' ? '320px' : '180px', display: 'flex', gap: '0',
                border: '1px solid #e2e8f0', borderRadius: '12px', padding: '8px', background: '#f8fafc'
            }}>
                <Form.Item className="mb-0" style={{ flex: 1, marginBottom: 0 }} name="DepartDate">
                    <DatePicker open={false} className="w-full" style={{ height: '52px' }}
                        variant="borderless" placeholder="Ngày đi" format="DD/MM/YYYY" minDate={dayjs()}
                        locale={locale} allowClear={false} inputReadOnly
                        onOpenChange={() => onOpenChange("DepartDate")}
                    />
                </Form.Item>
                {tripType === "roundTrip" && (
                    <>
                        <div style={{ width: '1px', background: '#e2e8f0', margin: '8px 0' }} />
                        <Form.Item className="mb-0" style={{ flex: 1, marginBottom: 0 }} name="ReturnDate" rules={[{ required: true, message: "Chọn ngày về!" }]}>
                            <DatePicker open={false} className="w-full" style={{ height: '52px' }}
                                variant="borderless" placeholder="Ngày về" format="DD/MM/YYYY"
                                minDate={form.getFieldValue("DepartDate") ? dayjs(form.getFieldValue("DepartDate")) : dayjs()}
                                locale={locale} allowClear={false} inputReadOnly
                                onOpenChange={() => onOpenChange("ReturnDate")}
                            />
                        </Form.Item>
                    </>
                )}
            </div>

            {/* Passenger Count Summary */}
            <div style={{
                width: '180px', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px 16px',
                background: '#f8fafc', display: 'flex', flexDirection: 'column', justifyContent: 'center', cursor: 'pointer'
            }}>
                <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>Hành khách</div>
                <div style={{ fontWeight: 700, color: '#1e293b', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '15px' }}>
                    <span>{(form.getFieldValue("Adt") || 1) + (form.getFieldValue("Chd") || 0) + (form.getFieldValue("Inf") || 0)} Hành khách</span>
                </div>
            </div>

            <Button type="primary" htmlType="submit" style={{
                height: '58px', padding: '0 28px', background: 'linear-gradient(135deg, #f97316, #ea580c)',
                borderRadius: '12px', fontSize: '16px', fontWeight: 700, border: 'none',
                boxShadow: '0 4px 14px rgba(249,115,22,0.35)', letterSpacing: '0.5px'
            }}>
                TÌM CHUYẾN BAY
            </Button>
        </div>

        {/* Passenger Inputs */}
        <div style={{
            marginTop: '16px', padding: '16px 20px', border: '1px solid #e2e8f0',
            borderRadius: '12px', background: '#f8fafc', display: 'flex', gap: '32px',
            alignItems: 'center', justifyContent: 'flex-start', width: 'fit-content'
        }}>
            <CustomInputNumber label="Người lớn" des="Từ 12 tuổi" max={9} min={1} name="Adt" form={form} />
            <div style={{ width: '1px', height: '40px', background: '#e2e8f0' }} />
            <CustomInputNumber label="Trẻ em" max={9} des="Từ 2 - 11 tuổi" min={0} name="Chd" form={form} />
            <div style={{ width: '1px', height: '40px', background: '#e2e8f0' }} />
            <CustomInputNumber label="Em bé" max={adtCount || 9} des="Dưới 2 tuổi" min={0} name="Inf" form={form} />
        </div>
    </Form>
                </div >
            </div >

    {/* Content Bottom */ }
    < div style = {{ flex: 1, width: '100%', maxWidth: '1200px', margin: '0 auto', paddingTop: '40px', paddingBottom: '48px', paddingLeft: '24px', paddingRight: '24px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: 700, color: '#1e293b', marginBottom: '24px' }}>Ưu đãi vé máy bay mới nhất</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
                    {[
                        { city: 'Đà Nẵng', color: '#3b82f6', image: '/images/danang_new.jpg' },
                        { city: 'Phú Quốc', color: '#8b5cf6', image: '/images/phuquoc.jpg' },
                        { city: 'Nha Trang', color: '#06b6d4', image: '/images/nhatrang.jpg' }
                    ].map((item, i) => (
                        <div key={i} style={{
                            borderRadius: '16px', overflow: 'hidden', background: 'white',
                            border: '1px solid #e2e8f0', cursor: 'pointer', transition: 'all 0.25s',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
                        }}>
                            <div style={{
                                height: '160px', width: '100%',
                                background: item.image ? `url(${item.image}) center/cover no-repeat` : `linear-gradient(135deg, ${item.color}22, ${item.color}44)`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                {!item.image && <span style={{ fontSize: '40px' }}>✈️</span>}
                            </div>
                            <div style={{ padding: '16px' }}>
                                <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '16px', marginBottom: '4px' }}>Bay đến {item.city}</div>
                                <div style={{ color: '#64748b', fontSize: '14px' }}>Giá vé từ <span style={{ color: '#f97316', fontWeight: 700 }}>990.000đ</span></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div >

    {/* Airport Selection Drawer */ }
{
    !loadingAirPorts && (
        <Drawer
            title={<h1 style={{ fontSize: '20px', fontWeight: 700, color: '#1e3a5f', margin: 0 }}>Chọn điểm {nameField === "startpoint" ? "đi" : "đến"}</h1>}
            placement="right" width={500} open={openDrawer} onClose={() => setOpenDrawer(false)}
            styles={{ body: { padding: '20px 24px', overflow: 'auto' } }}
        >
            <Input
                placeholder="Tìm kiếm thành phố, mã sân bay..."
                value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                style={{ marginBottom: '20px', height: '46px', borderRadius: '10px', fontSize: '15px' }}
                prefix={<svg style={{ width: '18px', height: '18px', color: '#94a3b8', marginRight: '8px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>}
            />
            <div className="airport-list" style={{ overflow: 'auto', height: 'calc(100vh - 160px)', paddingRight: '8px', paddingLeft: '4px' }}>
                {!!filterAirports.length && (
                    <div style={{ marginBottom: '24px' }}>
                        <h4 style={{ marginBottom: '12px', fontSize: '16px', fontWeight: 700, color: '#2563eb', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ width: '3px', height: '18px', background: '#2563eb', borderRadius: '2px', display: 'inline-block' }} /> Việt Nam
                        </h4>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                            {filterAirports.map((item) => (
                                <div key={item.code} onClick={() => handleSelect(item.code)}
                                    style={{
                                        display: 'flex', flexDirection: 'column', padding: '12px', borderRadius: '10px',
                                        border: '1px solid #e2e8f0', cursor: 'pointer', transition: 'all 0.2s',
                                        background: 'white'
                                    }}>
                                    <span style={{ fontWeight: 700, color: '#1e293b' }}>{item?.namevn}</span>
                                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>{item.code} - Sân bay {item?.airports?.[0]?.namevn || item?.namevn}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {filterAirportsFor.map((item, idx) => (
                    <div key={idx} style={{ marginBottom: '24px' }}>
                        <h4 style={{ marginBottom: '12px', fontSize: '16px', fontWeight: 700, color: '#2563eb', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ width: '3px', height: '18px', background: '#2563eb', borderRadius: '2px', display: 'inline-block' }} /> {item?.[0]?.countrynamevn}
                        </h4>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                            {item?.map((airport) => (
                                <div key={airport.code} onClick={() => handleSelect(airport.code)}
                                    style={{
                                        display: 'flex', flexDirection: 'column', padding: '12px', borderRadius: '10px',
                                        border: '1px solid #e2e8f0', cursor: 'pointer', transition: 'all 0.2s',
                                        background: 'white'
                                    }}>
                                    <span style={{ fontWeight: 700, color: '#1e293b' }}>{airport?.namevn}</span>
                                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>{airport.code}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </Drawer>
    )
}
        </div >
    );
};

export default DesktopStep1;
